/**
 * Feature Flags
 * Zentrale Steuerung für noch nicht freigegebene Features.
 * Bei Freigabe einfach auf `true` setzen.
 */

export const FEATURE_FLAGS = {
  /** Leadership Focus Chat (CustomGPT) – Links auf Startseite, Footer & Team-Seite */
  showChatBot: true,
} as const;

export const CHATBOT_URL =
  "https://chatgpt.com/g/g-6985b0a2a4f88191b258bb88bda94a66-leadership-focus-chat";
